import CardElementPhoto from './CardElementPhoto';

export default CardElementPhoto;
